export function setElementVisible(elem, visible) {
  visible ? elem.removeAttribute('hidden') : elem.setAttribute('hidden', '');
}
